__webpack_require__.p = "https://cdn.medprev.online/web-app/assets/bbc3e335/_next/";